export default __webpack_public_path__ + "static/artwork1-1449abc0e1b8c919c3b748d262948e60.webp";